angular.module('app').config([
  '$locationProvider',
  '$routeProvider',
  function config($locationProvider, $routeProvider) {
    $locationProvider.hashPrefix('');

    $routeProvider.otherwise({ template: '' });
  },
]);

// export default function (appModule) {
//   appModule.config([
//     '$routeProvider',
//     '$locationProvider',
//     function ($routeProvider, $locationProvider) {
//       $locationProvider.hashPrefix('');
//       // $locationProvider.html5Mode(true);

//       $routeProvider.otherwise({ template: '' });
//     },
//   ]);
// }
